// ── 보스별 드롭 아이템 데이터 ──────────────────────────
// 출처: 정심심 블로그 (2026.04.21) + 메이플스토리 공식 가이드
// diff: '공통'=모든 난이도, 그 외=해당 난이도에서만 드롭
// tradeable: true=경매장 거래 가능, false=거래 불가

export const BOSS_DROP_DATA = [
  {
    name: "자쿰",
    bossIcon: "",
    sec: {"이지": "daily", "노멀": "daily", "카오스": "weekly"},
    drops: [
      {
        diff: "이지/노멀",
        name: "자쿰의 투구",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "이지/노멀",
        name: "분노한 자쿰의 투구",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "이지/노멀",
        name: "분노한 자쿰의 벨트",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "이지/노멀",
        name: "자쿰의 나뭇가지",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "이지/노멀",
        name: "자쿰의 포이즈닉 무기",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "이지/노멀",
        name: "아쿠아틱 레터 눈장식",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "응축된 힘의 결정석",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
    ],
  },
  {
    name: "혼테일",
    bossIcon: "",
    sec: {"이지": "daily", "노멀": "daily", "카오스": "daily"},
    drops: [
      {
        diff: "공통",
        name: "실버블라썸 링",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "데아 시두스 이어링",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "혼테일의 목걸이",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "파풀라투스",
    bossIcon: "",
    sec: {"이지": "daily", "노멀": "daily", "카오스": "weekly"},
    drops: [
      {
        diff: "이지/노멀",
        name: "파풀라투스 마크",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "파풀라투스의 시계 의자",
        itemIcon: "",
        tradeable: false,
        note: "거래불가/가구",
      },
    ],
  },
  {
    name: "카웅",
    bossIcon: "",
    sec: {"노멀": "daily"},
    drops: [
    ],
  },
  {
    name: "힐라",
    bossIcon: "",
    sec: {"노멀": "daily", "하드": "daily"},
    drops: [
      {
        diff: "노멀",
        name: "네크로 세트",
        itemIcon: "",
        tradeable: true,
        note: "세트장비",
      },
      {
        diff: "하드",
        name: "[펫 상자] 다크 소울",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "지옥의 불꽃",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "피에르",
    bossIcon: "",
    sec: {"노멀": "daily", "카오스": "weekly"},
    drops: [
      {
        diff: "노멀",
        name: "피에르 모자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "조롱의 조각(150제 트릭스터 하의)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "즐거운 피에르",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "카오스",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "반반",
    bossIcon: "",
    sec: {"노멀": "daily", "카오스": "weekly"},
    drops: [
      {
        diff: "노멀",
        name: "반반 모자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "시간의 조각(150제 이글아이 상의)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "반반과 함께",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "카오스",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "블러디퀸",
    bossIcon: "",
    sec: {"노멀": "daily", "카오스": "weekly"},
    drops: [
      {
        diff: "노멀",
        name: "퀸의 티아라",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "절규의 조각(150제 하이네스 모자)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "무서워요 퀸",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "카오스",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "벨룸",
    bossIcon: "",
    sec: {"노멀": "daily", "카오스": "weekly"},
    drops: [
      {
        diff: "노멀",
        name: "벨룸의 헬름",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "파멸의 조각(150제 파프니르 무기)",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "노멀",
        name: "기암괴석 의자",
        itemIcon: "",
        tradeable: true,
        note: "가구",
      },
      {
        diff: "카오스",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "반 레온",
    bossIcon: "",
    sec: {"이지": "daily", "노멀": "daily", "하드": "daily"},
    drops: [
      {
        diff: "공통",
        name: "로얄 반 레온 세트",
        itemIcon: "",
        tradeable: true,
        note: "세트장비",
      },
      {
        diff: "공통",
        name: "이피아의 반지",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "이피아의 귀걸이",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "이피아의 목걸이",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "아카이럼",
    bossIcon: "",
    sec: {"이지": "daily", "노멀": "daily"},
    drops: [
      {
        diff: "공통",
        name: "도미네이터 펜던트",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메커네이터 펜던트",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "태초의 정수",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
    ],
  },
  {
    name: "매그너스",
    bossIcon: "",
    sec: {"이지": "daily", "노멀": "daily", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "노바 세트",
        itemIcon: "",
        tradeable: true,
        note: "세트장비",
      },
      {
        diff: "공통",
        name: "로얄 블랙메탈 숄더",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "크리스탈 웬투스 뱃지",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "저주받은 카이세리움",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "하드",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "핑크빈",
    bossIcon: "",
    sec: {"노멀": "daily", "카오스": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "핑크빛 성배",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "골든 클로버 벨트",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "블랙빈 마크",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "핑크빈 모자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "핑크빈 슈트",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "시그너스",
    bossIcon: "",
    sec: {"이지": "weekly", "노멀": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "드래곤테일 메이지숄더",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "검은 파괴의 조각(140제 여제 무기)",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "검은 수호의 조각(140제 여제 방어구)",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
    ],
  },
  {
    name: "스우",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly", "익스트림": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "특수형 에너지 코어(S급)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀/하드",
        name: "스우의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "홍옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드/익스트림",
        name: "앱솔랩스 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "하드/익스트림",
        name: "앱솔랩스 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "하드/익스트림",
        name: "루즈 컨트롤 머신 마크",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "스우로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "익스트림",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "컴플리트 언더컨트롤",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "섬멸병기 스우로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "익스트림",
        name: "섬멸병기 스우의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 실버 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "데미안",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "뒤틀린 낙인의 영혼석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "루인 포스실드",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "공통",
        name: "데미안의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "홍옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "마력이 깃든 안대",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "데미안로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "하드",
        name: "앱솔랩스 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "하드",
        name: "앱솔랩스 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 실버 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "가디언 엔젤 슬라임",
    bossIcon: "",
    sec: {"노멀": "weekly", "카오스": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "가디언 엔젤 링",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "흑옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 실버 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "루시드",
    bossIcon: "",
    sec: {"이지": "weekly", "노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "루시드의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀/하드",
        name: "나비날개 물방울석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀/하드",
        name: "트와일라이트 마크",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "이지",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "홍옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "몽환의 벨트",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "루시드로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "하드",
        name: "아케인셰이드 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "하드",
        name: "아케인셰이드 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 실버 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "윌",
    bossIcon: "",
    sec: {"이지": "weekly", "노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "윌의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀/하드",
        name: "코브웹 물방울석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀/하드",
        name: "트와일라이트 마크",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "이지",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "홍옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "저주받은 마도서 선택 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "거울세계의 코어 젬스톤",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "아케인셰이드 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "하드",
        name: "아케인셰이드 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 실버 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "더스크",
    bossIcon: "",
    sec: {"노멀": "weekly", "카오스": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "에스텔라 이어링",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "흑옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "거대한 공포",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "아케인셰이드 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "카오스",
        name: "아케인셰이드 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 실버 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "진 힐라",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "데이브레이크 펜던트",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "아케인셰이드 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "공통",
        name: "아케인셰이드 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "진 힐라의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "홍옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "흑옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "고통의 근원",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 실버 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "듄켈",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "에스텔라 이어링",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "듄켈의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "녹옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "흑옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "커맨더 포스 이어링",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "아케인셰이드 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "하드",
        name: "아케인셰이드 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 실버 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "검은 마법사",
    bossIcon: "",
    sec: {"하드": "monthly", "익스트림": "monthly"},
    drops: [
      {
        diff: "공통",
        name: "창세의 뱃지",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "아케인셰이드 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "공통",
        name: "아케인셰이드 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "익셉셔널 해머 (벨트)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "봉인된 제네시스 무기 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 골드 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "선택받은 세렌",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly", "익스트림": "weekly"},
    drops: [
      {
        diff: "노멀/하드/익스트림",
        name: "데이브레이크 펜던트",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드/익스트림",
        name: "미트라의 코어 젬스톤",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "흑옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "미트라의 분노 선택 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "익스트림",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "미트라의 분노 선택 상자",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "익스트림",
        name: "익셉셔널 해머 (얼굴장식)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 골드 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "감시자 칼로스",
    bossIcon: "",
    sec: {"이지": "weekly", "노멀": "weekly", "카오스": "weekly", "익스트림": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "칼로스의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀/카오스/익스트림",
        name: "니키로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "노멀/카오스/익스트림",
        name: "생명의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "이지",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "남겨진 칼로스의 의지 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "카오스",
        name: "남겨진 칼로스의 의지",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "카오스",
        name: "의지의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "익스트림",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "남겨진 칼로스의 의지",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "익스트림",
        name: "의지의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "익스트림",
        name: "익셉셔널 해머 (눈장식)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 골드 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "최초의 대적자",
    bossIcon: "",
    sec: {"이지": "weekly", "노멀": "weekly", "하드": "weekly", "익스트림": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "최초의 대적자 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀/하드/익스트림",
        name: "대적자로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "노멀/하드/익스트림",
        name: "생명의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "이지",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "이어진 고대의 결의 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "이어진 고대의 결의",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "불멸의 유산",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "하드",
        name: "고대의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "익스트림",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "이어진 고대의 결의",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "불멸의 유산",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "익스트림",
        name: "고대의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "익스트림",
        name: "익셉셔널 해머 (훈장)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "카링",
    bossIcon: "",
    sec: {"이지": "weekly", "노멀": "weekly", "하드": "weekly", "익스트림": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "카링의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀/하드/익스트림",
        name: "카링로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "이지",
        name: "뒤엉킨 흉수의 고리 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "이지",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "뒤엉킨 흉수의 고리 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "혼돈의 칠흑 장신구 상자",
        itemIcon: "",
        tradeable: true,
        note: "악세서리",
      },
      {
        diff: "노멀",
        name: "생명의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "뒤엉킨 흉수의 고리",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "흉수의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "하드",
        name: "혼돈의 칠흑 장신구 상자",
        itemIcon: "",
        tradeable: true,
        note: "악세서리",
      },
      {
        diff: "익스트림",
        name: "뒤엉킨 흉수의 고리",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "익스트림",
        name: "흉수의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "익스트림",
        name: "혼돈의 칠흑 장신구 상자",
        itemIcon: "",
        tradeable: true,
        note: "악세서리",
      },
      {
        diff: "익스트림",
        name: "익셉셔널 해머 (귀고리)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드/익스트림",
        name: "신념의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
      {
        diff: "공통",
        name: "메멘토 브론즈 에디셔널 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "메멘토 골드 큐브 (200제)",
        itemIcon: "",
        tradeable: true,
      },
    ],
  },
  {
    name: "찬란한 흉성",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "흉성로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "공통",
        name: "혼돈의 칠흑 장신구 상자",
        itemIcon: "",
        tradeable: true,
        note: "악세서리",
      },
      {
        diff: "공통",
        name: "찬란한 흉성 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "황홀한 환상의 단편 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "생명의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "백옥의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "황홀한 환상의 단편",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "황홀한 악몽",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "하드",
        name: "환상의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "하드",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "신념의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
    ],
  },
  {
    name: "림보",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "림보로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "공통",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "신념의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "혼돈의 칠흑 장신구 상자",
        itemIcon: "",
        tradeable: true,
        note: "악세서리",
      },
      {
        diff: "공통",
        name: "람보의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "왜곡된 욕망의 결정 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "왜곡된 욕망의 결정",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "근원의 속삭임",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "하드",
        name: "욕망의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
    ],
  },
  {
    name: "발드릭스",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "발드릭스로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "공통",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "신념의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "혼돈의 칠흑 장신구 상자",
        itemIcon: "",
        tradeable: true,
        note: "악세서리",
      },
      {
        diff: "공통",
        name: "발드릭스의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "영원한 충성의 흔적 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "영원한 충성의 흔적",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "죽음의 맹세",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "하드",
        name: "맹세의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
    ],
  },
  {
    name: "유피테르",
    bossIcon: "",
    sec: {"노멀": "weekly", "하드": "weekly"},
    drops: [
      {
        diff: "공통",
        name: "유피테르로이드",
        itemIcon: "",
        tradeable: true,
        note: "로이드",
      },
      {
        diff: "공통",
        name: "생명의 보스 반지 상자",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "신념의 연마석",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "공통",
        name: "혼돈의 칠흑 장신구 상자",
        itemIcon: "",
        tradeable: true,
        note: "악세서리",
      },
      {
        diff: "공통",
        name: "유피테르의 소울 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "노멀",
        name: "뒤틀린 갈망의 편린 조각",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "뒤틀린 갈망의 편린",
        itemIcon: "",
        tradeable: true,
      },
      {
        diff: "하드",
        name: "오만의 원죄",
        itemIcon: "",
        tradeable: true,
        note: "무기",
      },
      {
        diff: "하드",
        name: "갈망의 에테르넬 방어구 상자",
        itemIcon: "",
        tradeable: true,
        note: "방어구",
      },
      {
        diff: "공통",
        name: "솔 에르다의 기운",
        itemIcon: "",
        tradeable: false,
        note: "거래불가",
      },
      {
        diff: "공통",
        name: "놀라운 긍정의 혼돈 주문서 60%",
        itemIcon: "",
        tradeable: true,
        note: "스크롤",
      },
    ],
  },
];

export function getBossDrops(bossName, diff) {
  const boss = BOSS_DROP_DATA.find(b => b.name === bossName);
  if (!boss) return [];
  return boss.drops.filter(d => {
    if (!d.tradeable) return false;
    if (!diff || d.diff === '공통') return true;
    return d.diff === diff || d.diff.split('/').includes(diff);
  });
}

export function getBossSec(bossName, diff) {
  const boss = BOSS_DROP_DATA.find(b => b.name === bossName);
  if (!boss) return 'weekly';
  return boss.sec[diff] || Object.values(boss.sec)[0] || 'weekly';
}

export function getBossIcon(bossName) {
  const boss = BOSS_DROP_DATA.find(b => b.name === bossName);
  return boss?.bossIcon || "";
}